import {Alert, Card, CardBody, CardHeader, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {AgentReservationGrid} from "./agent_reservation_grid";
import {getAgentReservations} from "../../services/reservation/reservation";
import {CardFooterPaginator} from "../system/cardFooterPaginator";
import {PaginateContext} from "../../context/paginate";

export function AgentReservationManagement() {

  const [AgentReservations, setAgentReservations] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [gridRowCount, setGridRowCount] = useState(10);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridSelectedRow, setGridSelectedRow] = useState(null);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(paginate) {
    const result = await getAgentReservations(paginate);
    if (result.status === 200) {
      const {reservationList, total_count} = result.data;
      setAgentReservations(reservationList || []);
      setGridTotalRowCount(total_count);
    }
  }

  useEffect(() => {
    const paginate = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    }).toString()

    getData(paginate)
  }, [lastDataRefresh, gridCurrentPage, gridRowCount, sortBy, sortType]);

  return (
    <PaginateContext.Provider value={{
      setSortBy: setSortBy,
      sortType: sortType,
      setSortType: setSortType,
      active: gridCurrentPage,
      setActive: setGridCurrentPage,
      totalRows: gridTotalRowCount,
      rowsCount: gridRowCount,
      setRowsCount: setGridRowCount,
      from: from,
      to: to,
    }}>
      <div className="">
        {/*<AgentReservationForm AgentReservation={gridSelectedRow} open={modalOpen} setOpen={setModalOpen}*/}
        {/*                  setLastDataRefresh={setLastDataRefresh} setGridSelectedRow={setGridSelectedRow}/>*/}
        <Card className="pt-8">
          <CardHeader floated={true} shadow={false} className="rounded-none">
            <div className="mb-8 flex items-center justify-between gap-8">
              <Typography variant="h5" color="blue-gray">تایم‌های رزرو شده</Typography>
            </div>
            <div className="flex-row w-full textCenter">
              <Alert className="w-full" variant="gradient">
                <Typography className="w-full">
                  کاربر گرامی:
                  مشاوره های رزرو شده در ساعت مقرر به صورت خودکار انجام خواهند شد، لیکن در صورت عدم برقراری یا قطع
                  ارتباط
                  تلفنی در حین مکالمه (در بازه زمانی رزرو شده)، می توانید از دکمه تماس برای برقراری ارتباط مجدد اقدام
                  نمائید.
                </Typography>
              </Alert>
            </div>
          </CardHeader>

          <CardBody className="overflow-x-auto w-full">
            <AgentReservationGrid
              AgentReservations={AgentReservations}
              setModalOpen={setModalOpen}
              setSelectedRow={setGridSelectedRow}
            />
          </CardBody>

          <CardFooterPaginator/>
        </Card>
      </div>
    </PaginateContext.Provider>
  )
    ;
}